<template>
  <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
    <Rate class="rate" v-model="value" style="margin-top: 20px;"></Rate>
    <Button type="primary" @click="commit" style="width:100px;border-radius: 5px;margin-top: 20px;">确认</Button>
  </div>
</template>
<script>
import {apiPost} from "@/utils/api";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  data() {
    return {
      value: 0
    }
  },
  methods: {
    setRate(row) {
      this.id = row.id;
      this.value = row.starLv;
    },
    async commit() {
      showLoading();
      let res = await apiPost("api/auth/", "baseUserSign/updateUserInfoClientStarLv", {
        id: this.id,
        starLv: this.value
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.$emit('afterChange');
      } else {
        this.$Message.error(res.message);
      }
    }
  }
}
</script>
<style scoped>
.rate >>> .ivu-rate-star-full:before {
  color: red;
}
</style>